import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

export const DrawerItemTitle = styled(Typography.Title)`
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 10px 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled(Checkbox)<{ $order?: number }>`
  order: ${({ $order }) => $order || 1};
`;

export const CheckboxAction = styled(Typography.Caption)`
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const CardBox = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 55px;
  padding: 0 15px;
  border-radius: 7px;
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.palette.system.blue : theme.palette.primary.border};
  background-color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.palette.secondary.background
      : theme.palette.primary.background};
  margin-top: 10px;

  &:last-child {
    margin-bottom: 10px;
  }
`;

export const CardName = styled(Typography.Body)`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
